<template>
  <section class="contactWrapper">
    <div
      class=""
      v-if="stacked"
    >
      <contact-addresses
        :contact="recordData"
        :showTitle="showTitles"
      />
      <contact-phones
        :contact="recordData"
        :showTitle="showTitles"
      />
      <contact-emails
        :contact="recordData"
        :showTitle="showTitles"
      />
    </div>
    <!-- Record Data -->
    <div
      class="row custom-record-row"
      v-else
    >
      <div class="col-md-4 custom-record-panel">
        <contact-addresses
          :contact="recordData"
          :showTitle="showTitles"
        />
      </div>
      <div class="col-md-4 custom-record-panel">
        <contact-phones
          :contact="recordData"
          :showTitle="showTitles"
        />
      </div>
      <div class="col-md-4 custom-record-panel">
        <contact-emails
          :contact="recordData"
          :showTitle="showTitles"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import ContactAddresses from '@/components/contacts/listings/contact-addresses'
import ContactPhones from '@/components/contacts/listings/contact-phones'
import ContactEmails from '@/components/contacts/listings/contact-emails'
export default {
  name: 'user-record',
  components: {
    ContactAddresses,
    ContactPhones,
    ContactEmails
  },
  props: {
    recordData: Object,
    viewing: String,
    stacked: {
      type: Boolean,
      default: false
    },
    showTitles: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedId: 0,
      isShow: false
    }
  },
  async mounted() {
    await this.getAddresses()
    await this.getPhones()
    await this.getEmails()
  },
  methods: {
    ...mapActions('contacts', [
      'getContactAddresses',
      'getContactPhones',
      'getContactEmails'
    ]),
    async getAddresses() {
      await this.getContactAddresses(this.recordData.contact)
    },
    async getPhones() {
      await this.getContactPhones(this.recordData.contact)
    },
    async getEmails() {
      await this.getContactEmails(this.recordData.contact)
    }
  }
}
</script>
<style lang="scss" scoped>
.contactWrapper {
  cursor: pointer;
  position: relative;
}
.contactWrapper:hover {
  background-color: #c1caff;
}
.contactNumber {
  font-size: 1.2em;
  font-weight: 700;
}
.contactLabel {
  font-size: 1em;
  font-weight: 600;
}
.contactData {
  font-size: 1em;
  font-weight: 400;
}
.actionWrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.custom-record-row {
  margin-left: 0;
  margin-right: 0;
}
.custom-record-panel {
  padding: 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/users/listings/user-record.vue